/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useNoItemsTextStyles = makeStyles(() => ({
  root: {
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.11px',
    fontWeight: 400,
  },
}));
